import { render, staticRenderFns } from "./multiRowTable.vue?vue&type=template&id=348a072c&scoped=true&"
import script from "./multiRowTable.vue?vue&type=script&lang=js&"
export * from "./multiRowTable.vue?vue&type=script&lang=js&"
import style0 from "./multiRowTable.vue?vue&type=style&index=0&id=348a072c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348a072c",
  null
  
)

export default component.exports